import { ExpandCircleDown } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
export default function ChildrenBookDevelopement() {
  return (
    <Grid container m={2}>
      <Grid item>
        <Typography fontWeight={700}>
          Developmentally Appropriate Children’s Books
        </Typography>
        <Typography>
          For each book, provide the title, author, publisher, copyright date,
          and a short summary. Each book should be about a different topic
          related to children’s lives and challenges.
        </Typography>
      </Grid>

      <Grid item marginLeft={2}>
        <Typography component="span">Book topics might include:</Typography>
        <Typography component="div">
          <ul>
            <li>Cultural or linguistic group identity</li>
            <li> Gender identity</li>

            <li> Children with disabilities</li>
            <li> Separation/divorce/remarriage/family structures</li>
            <li> Everyday activities and routines</li>
            <li>
              Other topics that reflect the children and families with whom you
              work
            </li>
          </ul>
        </Typography>
      </Grid>

      <Grid item mb={2}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandCircleDown sx={{ color: "#CC581F" }} />}
          >
            <Typography fontWeight={700}>Example- Do Not Copy</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container p={2} spacing={2}>
              <Grid item container xs={12} spacing={2}>
                <Grid item xs={6}>
                  <Typography fontWeight={700}>*Title</Typography>
                  <Typography>Goodnight Moon</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography fontWeight={700}>*Author</Typography>
                  <Typography>Margret Wise Brown</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography fontWeight={700}>*Publisher</Typography>
                  <Typography>Harper & Brothers</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography fontWeight={700}>*Copyright</Typography>
                  <Typography>1947</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography fontWeight={700}>*Description</Typography>
                  <Typography>
                    A young bunny says goodnight to the objects and creatures in
                    a green-walled bedroom, drifting gradually to sleep as the
                    lights dim and the moon glows in a big picture window.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
}
